module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/error-no-results-48a8917f408ea36902248bf0eb605d4a.svg";